import en from 'Locales/en.yml'

export default {
  ...en
}
